import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CogSvg = function CogSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 8.481c-.915 0-1.794.371-2.441 1.031A3.55 3.55 0 0 0 8.547 12c0 .933.364 1.828 1.012 2.488A3.42 3.42 0 0 0 12 15.518c.915 0 1.794-.37 2.442-1.03A3.55 3.55 0 0 0 15.454 12c0-.933-.364-1.828-1.011-2.488A3.42 3.42 0 0 0 12 8.482m-1.413 2.079A1.98 1.98 0 0 1 12 9.963c.53 0 1.038.215 1.413.597S14 11.46 14 12s-.21 1.058-.586 1.44a1.98 1.98 0 0 1-1.413.597 1.98 1.98 0 0 1-1.414-.597A2.06 2.06 0 0 1 10 12c0-.54.21-1.058.586-1.44",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 2H9v2.444a8 8 0 0 0-1.923 1.133L5 4.354 2 9.646l2.079 1.223a8.3 8.3 0 0 0 0 2.262L2 14.354l2.999 5.292 2.08-1.223A8 8 0 0 0 9 19.556V22H15v-2.444a8 8 0 0 0 1.923-1.133L19 19.646 22 14.354l-2.079-1.223a8.3 8.3 0 0 0 0-2.262L22 9.646l-2.999-5.292-2.08 1.223A8 8 0 0 0 15 4.444zm-4.544 3.497V3.481h3.09v2.016l.499.168a6.5 6.5 0 0 1 2.314 1.364l.393.358 1.717-1.01 1.545 2.727-1.715 1.009.108.524a6.8 6.8 0 0 1 0 2.726l-.108.524 1.715 1.01-1.545 2.725-1.716-1.009-.393.358a6.5 6.5 0 0 1-2.316 1.364l-.5.168v2.015h-3.09v-2.015l-.499-.168a6.5 6.5 0 0 1-2.314-1.364l-.393-.358-1.717 1.01-1.545-2.727L5.7 13.887l-.106-.524a6.8 6.8 0 0 1 0-2.726l.106-.524-1.714-1.01 1.545-2.725 1.716 1.009.393-.358a6.5 6.5 0 0 1 2.316-1.364z",
    clipRule: "evenodd"
  }));
};
export var Cog = function Cog(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CogSvg
  }));
};